define(['jquery', 'erv_framework', 'booking_rules'], function ($, ERVFramework, ERVBookingRules) {
	var WarList = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.framework = new ERVFramework();
		self.bookingRules = new ERVBookingRules();

		self.warlistRules = function () {
			var isCorp = self.$ervBody.find('#IsCorporate').val() == "True";
			if (!isCorp) {
				self.$ervBody.find('[data-js=continuetrigger], .btn.magnific-popup').each(function () {
					$(this).prop('disabled', false);
					$(this).removeClass('is-inactive');
				});
			}

			var warriskCountries = '';
			self.$ervBody.find('.destination input[name="Countries"]').each(function () {
				warriskCountries += 'Countries=' + $(this).val() + '&';
			});

			if (warriskCountries.length && !isCorp) {
				$.ajax({ type: 'post', url: '/booking/warrisk-consent', data: warriskCountries.substring(0, warriskCountries.length - 1) });
			}
		}

		self.applyRules = function () {
			if (self.$ervBody.find('#IsCorporate').val() == "False") {
				return;
			}

			self.$ervBody.find('[data-js=continuetrigger], .btn.magnific-popup').each(function () {
				$(this).prop('disabled', true);
				$(this).addClass('is-inactive');
				$(this).on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
				});
			});
		}
	}

	WarList.prototype.init = function () {
		var self = this;

		if (self.$ervBody.find('#SearchHasWarCountries').length > 0 && self.$ervBody.find('#SearchHasWarCountries').val() === 'True') {
			setTimeout(function () {
				self.framework.popup.openPopup(
					'#warlist-warning',
					{
						elementParse: function (item) {
							$(item.src).removeClass('hide');
							$(item.src).find('[data-js="warlistok"]').on('click', function (e) {
								e.preventDefault();
								$.magnificPopup.close();
							});
						},
						beforeClose: function () {
							self.warlistRules();
						},
						afterClose: function () {
							if (self.$ervBody.find('.bookingselectproductpage').length) {
								self.bookingRules.initHomeInsurance();
							}
						}
					},
					true, false
				);

			}, 2);

			$(document).on('products-loaded', function () {
				self.applyRules();
			});
		}
	};

	return WarList;
});